import React, {useRef, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import BankSelectModal from "../../../components/bank/BankSelectModal";
import {BankAccountCheckTypes} from "../../../types/common/bank.account.types";
import {checkDepositorAndSaveAccount} from "../../../api/commonApi";
import {alertAfterFunction, defaultAlert} from "../../../utils/alert";


export default function AccountVerification() {
    const navigate = useNavigate();
    const location = useLocation();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [selectedBank, setSelectedBank] = useState({
        code: '',
        name: ''
    });


    const [accountNo, setAccountNo] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isSubmittingRef = useRef(false);

    const handleOpenModal = () => setIsModalOpen(true);
    // 모달 닫기
    const handleCloseModal = () => setIsModalOpen(false);

    const handleSelectBank = (bankCode: string, bankName: string) => {
        setSelectedBank({code: bankCode, name: bankName});
        setIsModalOpen(false);
    };

    const [accountInfo, setAccountInfo] = useState({
        bankCd: '',
        bankName: '',
        account: ''
    });


    const accountAuthRequest = async () => {
        if (isSubmittingRef.current) return;
        isSubmittingRef.current = true;
        setIsSubmitting(true);

        // 계좌 인증
        try {
            const bankType: BankAccountCheckTypes = {
                bankCode: selectedBank.code,
                account: accountNo
            }
            const res = await checkDepositorAndSaveAccount(bankType);

            if (res.data.code === "00") {
                alertAfterFunction("계좌 인증/변경에 성공하였습니다.", () => {
                    navigate('/wallet')
                });
            } else {
                defaultAlert(res.data.message);
            }
        } catch (err) {
            console.log(err);
        } finally {
            isSubmittingRef.current = false;
            setIsSubmitting(false);
        }
    };

    return (
        <>
            {(selectedBank.code !== '' && accountNo) && (
                <div className="bottom-btn">
                    <button onClick={accountAuthRequest} type="button" className="btn confirm" disabled={isSubmitting}>계좌 인증
                    </button>
                </div>
            )}

            <main className="container">
                <section className="tit-box-wrap">
                    <h2 className="headline">은행 계좌 인증을 진행해 주세요.</h2>
                    <p className="subtit">회원님의 실명과 계좌의 예금주가 일치해야 인증이 가능합니다.</p>
                </section>
                <form className="form-box">
                    <section className="bg-white">
                        <fieldset>
                            <legend>계좌 등록 폼</legend>
                        </fieldset>
                        <div className="inner-box">
                            <div className="form-item">
                                <label htmlFor="" className="input-tit">은행</label>
                                <button
                                    type="button"
                                    className="account-alert-btn"
                                    onClick={handleOpenModal}
                                >
                                    {selectedBank.name || '은행을 선택해 주세요'}
                                </button>
                            </div>
                            <div className="form-item">
                                <label className="input-tit">계좌번호</label>
                                <div className="line-input-box">
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        onChange={(e) => setAccountNo(e.target.value.replace(/\D/g, ''))}
                                    />
                                </div>
                            </div>
                            <div className="form-item">
                                <ul className="guidF-list">
                                    <li>은행 서버 점검 시간에는 계좌 인증이 불가하오니 유의하시기 바랍니다.</li>
                                </ul>
                            </div>
                        </div>
                    </section>
                </form>
            </main>

            {isModalOpen && (
                <BankSelectModal
                    onClose={handleCloseModal}
                    onSelect={handleSelectBank}
                />
            )}

        </>
    );
};